import { useEffect } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { doSetEstimateOrderRequestData } from '@/stores/reduxData'
import { RootState } from '@/stores/store'
import { localEstimateTarget } from '@/utils/utilLocalStorage'

export const useGetEstimateOrder = () => {
  const dispatch = useDispatch()

  const estimatedOrderRequest = useSelector((rootState: RootState) => rootState.reduxDataReducers.estimatedOrderRequest)

  useEffect(() => {
    if (!estimatedOrderRequest && localEstimateTarget.load()) {
      dispatch(doSetEstimateOrderRequestData(localEstimateTarget.load()))
    }

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [])

  return { estimatedOrderRequest }
}
